const utils = require('analytics/utils');
const anaConsts = require('analytics/constants');
const deepExtend = require('utils/deepExtend');
const basketUtils = require('utils/Basket');
const skuUtils = require('utils/Sku');
const locationUtils = require('utils/Location');
const anaUtils = require('analytics/utils');

module.exports = function (data) {
    const { isBIRBPageRewardModal } = data;

    const currentEvent = utils.getMostRecentEvent(anaConsts.LINK_TRACKING_EVENT);

    const actionEvent = isBIRBPageRewardModal ? 'Remove From Basket' : anaUtils.safelyReadProperty('eventInfo.attributes.actionInfo', currentEvent);

    deepExtend(currentEvent, {
        eventInfo: {
            attributes: {
                biRealTimePointStatus:
                    !isBIRBPageRewardModal && locationUtils.isBIRBPage() && skuUtils.isBiReward(data.sku) ? basketUtils.getAvailableBiPoints() : null,
                // Should anything be added to the removeFromBasket link
                // tracking event or removed from it, please do that here.
                biRewardType: data.sku.biType,
                actionInfo: actionEvent
            }
        }
    });
};
